import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Affix extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        leftRef: PropTypes.any,
        rightRef: PropTypes.any,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { floatAd5 },
            leftRef,
            rightRef,
        } = this.props;

        const affix = (
            <React.Fragment>
                <div ref={leftRef} />
                <div ref={rightRef} />
                <Ad content={floatAd5} styleName={styles.floatAd} />
            </React.Fragment>
        );

        return ReactDOM.createPortal(affix, document.body);
    }
}

export default errorBoundary(Affix);
